import { Button } from "components/DesignSystem/Button/Button";
import { CrossOutlined } from "components/icons/CrossOutlined";
import { Exclamation } from "components/icons/Exclamation";

export const ParsedFilingFieldErrorState = ({
  errorMessage,
  warningMessage,
  isRemovable = false,
  removeWarning,
}: {
  errorMessage?: string;
  warningMessage?: string;
  isRemovable: boolean;
  removeWarning?: () => void;
}) => {
  return (
    <div className="t-p-2.5 t-rounded-lg t-flex t-gap-2.5 t-bg-red-0 t-border t-border-solid t-border-red-10">
      <span className="t-text-red-70 -t-mt-1">
        <Exclamation />
      </span>
      <div className="t-text-body-sm t-text-text-60">
        {errorMessage || warningMessage}
      </div>
      {isRemovable && (
        <Button
          size="small"
          customType="ghost"
          onClick={() => removeWarning?.()}
        >
          <span className="t-text-neutral-40">
            <CrossOutlined stroke="1.4" size="16" />
          </span>
        </Button>
      )}
    </div>
  );
};
